import StatisticsHeader from '../StatisticsHeader'
import CompareAbilities from './CompareAbilities'
import CompareCompanies from './CompareCompanies'
import CompareJobTitles from './CompareJobTitles'
import UnemployedAbilities from './UnemployedAbilities'
import UnemployedGraduates from './UnemployedGraduates'

const StatisticsImprovementAreasPage = () => {
    return (
        <div className="w-full flex flex-col gap-6">
            <StatisticsHeader category="Areas de mejora" />
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-8">
                <div className="col-span-1 md:col-span-2">
                    <UnemployedGraduates />
                </div>
                <div className="col-span-1 md:col-span-3">
                    <UnemployedGraduates chart />
                </div>
            </div>
            <UnemployedAbilities />
            <CompareAbilities />
            <CompareCompanies />
            <CompareJobTitles />
        </div>
    )
}

export default StatisticsImprovementAreasPage
